export default __webpack_public_path__ + "static/media/Menu.58dd2b70.png";